import classNames from 'classnames';
import React, { FunctionComponent, HTMLAttributes, LabelHTMLAttributes } from 'react';
import styles from './styles.module.scss';
import { RequiredStrategy } from '../../Form';

export type RequiredProps = {
    required?: boolean;
    requiredStrategy?: RequiredStrategy;
};

export type LabelProps = LabelHTMLAttributes<HTMLLabelElement> & RequiredProps;

export const Label: FunctionComponent<LabelProps> = ({
    className,
    children,
    required = false,
    requiredStrategy = 'required',
    ...props
}) => {
    return (
        <label
            className={classNames(styles.label, className)}
            {...props}
            data-required={required}
            data-required-strategy={requiredStrategy}
        >
            {children}
        </label>
    );
};

export type LegendProps = HTMLAttributes<HTMLLegendElement> & RequiredProps;

export const Legend: FunctionComponent<LegendProps> = ({
    className,
    children,
    required = false,
    requiredStrategy = 'required',
    ...props
}) => {
    return (
        <legend
            className={classNames(styles.label, className)}
            {...props}
            data-required={required}
            data-required-strategy={requiredStrategy}
        >
            {children}
        </legend>
    );
};
